import { SparklesIcon } from "lucide-react";

import { Button } from "@/components/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
} from "@/components/dialog";
import { Modal } from "@/components/modal";

interface TemplateRequestModalProps {
  isOpen: boolean;
  onCreateNew: () => void;
  onDuplicate: () => void;
  onOpenChange: (isOpen: boolean) => void;
}

export function TemplateRequestModal({
  isOpen,
  onCreateNew,
  onDuplicate,
  onOpenChange,
}: TemplateRequestModalProps) {
  return (
    <Modal
      classNames={{ modal: "w-[400px]", modalOverlay: "!z-[70]" }}
      isDismissable
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog>
        <DialogBody className="p-6">
          <DialogCloseButton />

          <div className="flex flex-col gap-xl mb-6">
            <div className="size-12 shrink-0 grid place-items-center rounded-full bg-bg-brand-secondary">
              <SparklesIcon className="text-fg-brand-primary" size={24} />
            </div>

            <div className="flex flex-col gap-xs">
              <h2 className="text-lg font-semibold text-text-primary">
                This is a template request
              </h2>
              <p className="text-sm text-text-tertiary">
                This is a template request that shows an example of a
                well-structured design brief and how the design team typically
                responds.
              </p>
              <p className="text-sm text-text-tertiary">
                Use it as a reference when creating your own requests.
              </p>
            </div>
          </div>
        </DialogBody>

        <DialogFooter className="px-6 pb-6 pt-0">
          <div className="flex flex-col gap-sm w-full">
            <Button
              className="w-full"
              onPress={onDuplicate}
              size="lg"
              variant="primary"
            >
              Duplicate request
            </Button>

            <Button
              className="w-full"
              color="gray"
              onPress={onCreateNew}
              size="lg"
              variant="secondary"
            >
              Create new request
            </Button>
          </div>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
